import ChartDesigner from 'scoreboard/charts/model/chart-designer'

// A list of plot types that do not have X/Y axes
const NO_AXES = [
	'pie',
	'donut',
	'process',
	'cycle',
	'timeline',
	'funnel',
	'pyramid',
	'tree-map',
	'waffle',
	'filled-container',
	'filled-map',
	'spike-map',
	'bubble-map'
]

/**
 * Returns true if the given item represents a chart type that does not use axes
 *
 * @param {String|Chart|ChartDesigner|Chart.Series} hasPlotType
 */
function nonAxesPlotType(hasPlotType) {
	if (typeof hasPlotType === 'string') {
		return nonAxesPlotTypeString(hasPlotType)
	}

	if (hasPlotType instanceof ChartDesigner) {
		return nonAxesSeriesOrChartDesigner(hasPlotType)
	}
}

/**
 * Checks if the passed in item has a plot type that does not use axes. Series and
 * ChartDesigner's both have a plotType property, so either can be passed in
 *
 * @param {ChartDesigner|Chart.Series} seriesOrChartDesigner
 */
function nonAxesSeriesOrChartDesigner(seriesOrChartDesigner) {
	if (!seriesOrChartDesigner) return false
	return nonAxesPlotTypeString(seriesOrChartDesigner.get('plotType'))
}

/**
 * Determines if a string is a plot type that does not use axes
 * @param {String} plotType
 */
function nonAxesPlotTypeString(plotType) {
	return NO_AXES.includes(plotType)
}

export default nonAxesPlotType
nonAxesPlotType.__filename__ = 'charts/non-axes-plot-type.js'
